export class MemberReport {
  srno?: number = 0;
  moduleReportId: string;
  practiceId: number;
  memberId: number;
  title: string;
  description: string;
  isActive: boolean | string;
  createdOn?: Date | string;
  createdBy: number;
  updatedOn?: Date | string;
  updatedBy: number;
}

export class MemberReportListReqCommand {
  searchTerm: string = '';
  sortBy: number = 1;
  sortFieldName: string = '';
  pageNumber: number = 1;
  pageSize: number = 15;
  memberId?: number = 0;
  practiceId: number = 0;
  customerId: number = 0;
  moduleId: number = 0;
}

export class MemberReportListResp {
  memberModuleReportList: MemberReport[] = [];
  totalRecords: number = 0;
}

export class MemberReportViewList {
  moduleReportId: string;
  title: string;
  description: string;
}
